import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://qtozskzsrpiyrvaohrfh.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF0b3pza3pzcnBpeXJ2YW9ocmZoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzg3ODI3MjUsImV4cCI6MjA5NDM1ODcyNX0.8DdfS0qWhHZjhiuiDmwEDX7lKQfWWh01J1d5acqqRwQ'; // the anon public key

export const supabase = createClient(supabaseUrl, supabaseKey);
